export enum WebsiteExternalEventTypeEnum {
  UpdateRouting = 'updateRouting',
  UpdateAgreements = 'updateAgreements',
  AuctionOfferAdded = 'auctionOfferAdded',
  AuctionOfferUpdatedEndDatetime = 'auctionOfferUpdatedEndDatetime',
  AuctionSold = 'auctionSold',
  UserUpdated = 'userUpdated',
  SliderUpdated = 'sliderUpdated',
  SettingsUpdated = 'settingsUpdated',
  PublicProfileUpdated = 'publicProfileUpdated'
}
